import { BrowserFeatureDetector } from "../../../utils/BrowserFeatureDetector";
import { VintomErrorCode } from "./VintomErrorCode";

interface VintomErrorOptions {
  isLogAndSendToAnalytics?: boolean;
  isDisplayToUser?: boolean;
}

interface VintomErrorAdditionalInfo {
  playerVersion?: string;
  userAgent?: string;
  browserMajorVersion?: number;
  browserName?: string;
  operatingSystem?: string;
}

export class VintomError {
  private static DEFAULT_OPTIONS: VintomErrorOptions = {
    isLogAndSendToAnalytics: true,
    isDisplayToUser: true,
  };

  options: VintomErrorOptions;
  errorAdditionalInfo: VintomErrorAdditionalInfo;
  stackTrace: any;

  constructor(
    public errorCode: VintomErrorCode,
    public message: string,
    options?: VintomErrorOptions,
  ) {
    this.options = {
      ...VintomError.DEFAULT_OPTIONS,
      ...(options || {}),
    };

    this.errorAdditionalInfo = {};

    if (require("../../../../package.json").version) {
      this.errorAdditionalInfo.playerVersion = require("../../../../package.json").version;
    }

    if (navigator.userAgent) {
      this.errorAdditionalInfo.userAgent = navigator.userAgent;
    }

    if (BrowserFeatureDetector.getBrowserMajorVersion()) {
      this.errorAdditionalInfo.browserMajorVersion = BrowserFeatureDetector.getBrowserMajorVersion();
    }

    if (BrowserFeatureDetector.getBrowserName()) {
      this.errorAdditionalInfo.browserName = BrowserFeatureDetector.getBrowserName();
    }

    if (BrowserFeatureDetector.getOS()) {
      this.errorAdditionalInfo.operatingSystem = BrowserFeatureDetector.getOS();
    }

    if (Error().stack) {
      this.stackTrace = Error().stack;
    }
  }
}
